import { memo } from 'react';
import classes from 'classnames';
import HelpIcon from 'assets/icons/help.svg?react';
import styles from './HelpInfo.module.scss';
import Typography from '../Typography/Typography';

export type Props = {
  title: string;
  text: string;
  className?: string;
  dataTest?: string;
};

export default memo(function HelpInfo({
  title,
  text,
  className,
  dataTest = 'helpInfo',
}: Props) {
  return (
    <div
      className={classes(styles['help-wrapper'], className)}
      data-test={dataTest}
    >
      <div className={styles.icon}>
        <HelpIcon data-test={`${dataTest}-icon`} />
      </div>
      <div className={styles['help-info-wrapper']}>
        <Typography kind="h1" size="s" dataTest={`${dataTest}-title`}>
          {title}
        </Typography>
        <p
          className={styles['information-text']}
          dangerouslySetInnerHTML={{
            __html: text,
          }}
          data-test={`${dataTest}-text`}
        />
      </div>
    </div>
  );
});
